import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "./menu-bottom.sass";
import { ReactComponent as MenuIcon1 } from "../../assets/images/menu-icon-1.svg";
import { ReactComponent as MenuIcon2 } from "../../assets/images/menu-icon-2.svg";
import { ReactComponent as MenuIcon3 } from "../../assets/images/menu-icon-3.svg";
import { ReactComponent as MenuIcon4 } from "../../assets/images/menu-icon-4.svg";
import { StateContext } from "../../context/StateContext";
import { getRealFlags } from "../../utils/realFlags";

const MenuBottom = () => {
  const STATE = useContext(StateContext);

  if (!STATE.lastData || !STATE.subscribed || STATE.subscribed === null)
    return <React.Fragment />;

  const { is2Real } = getRealFlags(STATE.lastData);

  const menuItem = (to, tab, icon, text, disabled) => {
    const className = `menu-bottom-item${
      STATE.tab === tab ? " menu-bottom-item-active" : ""
    }${disabled ? " menu-bottom-item--disabled" : ""}`;

    if (disabled) {
      return (
        <div className={className}>
          {icon}
          <div className="item-text">{text}</div>
        </div>
      );
    }

    return (
      <Link to={to} className={className}>
        {icon}
        <div className="item-text">{text}</div>
      </Link>
    );
  };

  return (
    <div className="main-area-field _fixed-b">
      <div className="main-area">
        <div className="menu-bottom">
          {menuItem(
            `/device/${STATE.subscribed.id}`,
            "main",
            <MenuIcon1 className="item-icon" />,
            "пульт"
          )}
          {menuItem(
            `/device/${STATE.subscribed.id}/timers`,
            "timers",
            <MenuIcon2 className="item-icon" />,
            "таймеры",
            !is2Real
          )}
          {menuItem(
            `/device/${STATE.subscribed.id}/chimes`,
            "chimes",
            <MenuIcon3 className="item-icon" />,
            "КУРАНТЫ",
            !is2Real
          )}
          {menuItem(
            `/device/${STATE.subscribed.id}/settings`,
            "settings",
            <MenuIcon4 className="item-icon" />,
            "НАСТРОЙКИ"
          )}
        </div>
      </div>
    </div>
  );
};

export default MenuBottom;
